import { Model, belongsTo } from 'miragejs';

export default Model.extend({
  cmsOwnerId: belongsTo('user', { inverse: null }),
  cmsCreatorId: belongsTo('user', { inverse: null }),
  cmsModifierId: belongsTo('user', { inverse: null }),
  asset: belongsTo('asset', { inverse: null }),
  format: belongsTo('asset-format', { inverse: null }),
});
